import React, { useEffect, useState } from "react";
import api from '../utils/api.js';
import { URLS } from '../utils/urls.js';
import { Eye, EyeOff } from "lucide-react";
import Alert from "../components/Alert.jsx";
import { useTopLoader } from "../context/TopLoaderContext";

export default function AdminSettings() {
  const [settings, setSettings] = useState({
    stripe_secret_key: "",
    stripe_publishable_key: "",
    stripe_webhook_secret: "",
    
    // Monthly
    stripe_premium_price_monthly_id: "",
    stripe_premium_price_monthly_amount: "",

    // Yearly
    stripe_premium_price_yearly_id: "",
    stripe_premium_price_yearly_amount: "",

    eventbrite_api_key: "",
    eventbrite_client_id: "",
    eventbrite_redirect_url: "",

    maintenance_mode: "0",
    hide_invites: "false",
  });
const [showSecretKey, setShowSecretKey] = useState(false);
const [showWebhookKey, setShowWebhookKey] = useState(false);
const [showPublishableKey, setShowPublishableKey] = useState(false);
const [showEventbriteKey, setShowEventbriteKey] = useState(false);
const { start, stop } = useTopLoader();
  const [show, setShow] = useState(false);
  const [alertText, setAlert] = useState("");
  const [alertType, setAlertType] = useState("success");

  function ALERT(text, type="success") {
    setAlert(text);
    setAlertType(type);
    setShow(true);
  }


  useEffect(() => {
    const fetchSettings = async () => {
      start();
      try {
        const res = await api.get(URLS.SYSTEM_SETTINGS);
        setSettings(res.data);
         stop();
      } catch (err) {
        alert("Error fetching settings");
        console.error("Error fetching settings", err);
         stop();
      }
    };

    fetchSettings();
  }, []);

  const handleChange = (key, value) => {
    setSettings((prev) => ({ ...prev, [key]: value }));
  };

  const saveSettings = async () => {
    try {
      await api.post(URLS.SYSTEM_SETTINGS_BULK, settings);
      ALERT("Settings saved!");
      
    } catch (err) {
      console.error("Error saving settings:", err);
     ALERT("Request Failed", "error");
    }
  };

  return (
    <div className="min-h-screen bg-transparent p-8">
      <h2 className="text-2xl font-semibold text-gray-800 mb-8">
        ⚙️ Tribe25 Admin Settings
      </h2>

      <div className="flex flex-col space-y-6">

        {/* Stripe Secret Key */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">
            Stripe Secret Key
          </label>

          <div className="relative">
            <input
              type={showSecretKey ? "text" : "password"}
              value={settings.stripe_secret_key}
              onChange={(e) => handleChange("stripe_secret_key", e.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
      focus:ring-2 focus:ring-blue-400 focus:border-blue-400 pr-10"
            />

            <button
              type="button"
              onClick={() => setShowSecretKey(!showSecretKey)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
            >
              {showSecretKey ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>
       {/* Stripe Publishable Key */}
      <div className="flex flex-col max-w-[300px]">
        <label className="text-sm font-medium text-gray-700">
          Stripe Publishable Key
        </label>

        <div className="relative">
          <input
            type={showPublishableKey ? "text" : "password"}
            value={settings.stripe_publishable_key}
            onChange={(e) => handleChange("stripe_publishable_key", e.target.value)}
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400 pr-10"
          />

          <button
            type="button"
            onClick={() => setShowPublishableKey(!showPublishableKey)}
            className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
          >
            {showPublishableKey ? <EyeOff size={18} /> : <Eye size={18} />}
          </button>
        </div>
      </div>

        {/* Stripe Webhook Secret */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">
            Stripe Webhook Secret
          </label>

          <div className="relative">
            <input
              type={showWebhookKey ? "text" : "password"}
              value={settings.stripe_webhook_secret}
              onChange={(e) => handleChange("stripe_webhook_secret", e.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
      focus:ring-2 focus:ring-blue-400 focus:border-blue-400 pr-10"
            />

            <button
              type="button"
              onClick={() => setShowWebhookKey(!showWebhookKey)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
            >
              {showWebhookKey ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* --------------------------- */}
        {/* MONTHLY SUBSCRIPTION INPUTS */}
        {/* --------------------------- */}

        <h3 className="text-lg font-semibold text-gray-700 mt-6">Monthly Pricing</h3>

        {/* Monthly Price ID */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Monthly Price ID</label>
          <input
            type="text"
            value={settings.stripe_premium_price_monthly_id}
            onChange={(e) =>
              handleChange("stripe_premium_price_monthly_id", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* Monthly Amount */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Monthly Amount ($)</label>
          <input
            type="number"
            value={settings.stripe_premium_price_monthly_amount}
            onChange={(e) =>
              handleChange("stripe_premium_price_monthly_amount", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* --------------------------- */}
        {/* YEARLY SUBSCRIPTION INPUTS */}
        {/* --------------------------- */}

        <h3 className="text-lg font-semibold text-gray-700 mt-6">Yearly Pricing</h3>

        {/* Yearly Price ID */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Yearly Price ID</label>
          <input
            type="text"
            value={settings.stripe_premium_price_yearly_id}
            onChange={(e) =>
              handleChange("stripe_premium_price_yearly_id", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* Yearly Amount */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Yearly Amount ($)</label>
          <input
            type="number"
            value={settings.stripe_premium_price_yearly_amount}
            onChange={(e) =>
              handleChange("stripe_premium_price_yearly_amount", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* --------------------------- */}
        {/* EVENTBRITE SETTINGS */}
        {/* --------------------------- */}

        <h3 className="text-lg font-semibold text-gray-700 mt-6">Eventbrite Settings</h3>

        {/* Eventbrite API Key */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">
            Eventbrite API Key / Personal Token
          </label>

          <div className="relative">
            <input
              type={showEventbriteKey ? "text" : "password"}
              value={settings.eventbrite_api_key}
              onChange={(e) => handleChange("eventbrite_api_key", e.target.value)}
              className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
      focus:ring-2 focus:ring-blue-400 focus:border-blue-400 pr-10"
            />

            <button
              type="button"
              onClick={() => setShowEventbriteKey(!showEventbriteKey)}
              className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-600"
            >
              {showEventbriteKey ? <EyeOff size={18} /> : <Eye size={18} />}
            </button>
          </div>
        </div>

        {/* Eventbrite Client ID */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Eventbrite Client ID</label>
          <input
            type="text"
            value={settings.eventbrite_client_id}
            onChange={(e) =>
              handleChange("eventbrite_client_id", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          />
        </div>

        {/* Eventbrite Redirect URL */}
        <div className="flex flex-col max-w-[300px]">
          <label className="text-sm font-medium text-gray-700">Eventbrite Redirect URL</label>
          <input
            type="text"
            value={settings.eventbrite_redirect_url}
            onChange={(e) =>
              handleChange("eventbrite_redirect_url", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
            placeholder="https://yourdomain.com/admin/eventbrite/callback"
          />
        </div>


        {/* Maintenance Mode */}
        <div className="flex flex-col max-w-[300px] mt-6">
          <label className="text-sm font-medium text-gray-700">
            Maintenance Mode
          </label>
          <select
            value={settings.maintenance_mode}
            onChange={(e) =>
              handleChange("maintenance_mode", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          >
            <option value="0">OFF</option>
            <option value="1">ON</option>
          </select>
        </div>

        {/* Hide Invites Setting */}
        <div className="flex flex-col max-w-[300px] mt-6">
          <label className="text-sm font-medium text-gray-700">
            Hide Incomming Invites (Upgrade Required)
          </label>
          <select
            value={settings.hide_invites}
            onChange={(e) =>
              handleChange("hide_invites", e.target.value)
            }
            className="mt-1 w-full rounded-lg border border-gray-300 px-3 py-2 bg-white 
            focus:ring-2 focus:ring-blue-400 focus:border-blue-400"
          >
            <option value="false">OFF</option>
            <option value="true">ON</option>
          </select>
          <p className="text-xs text-gray-500 mt-1">
            If ON, users will see an "Upgrade" screen on Incomming Invites tab.
          </p>
        </div>
      </div>

      <button
        onClick={saveSettings}
        className="mt-10 bg-blue-600 hover:bg-blue-700 text-white font-semibold 
        px-6 py-3 rounded-lg shadow-md transition max-w-[300px]"
      >
        Save Settings
      </button>

      {show && (
        <Alert
          message={alertText}
          type={alertType}
          onClose={() => setShow(false)}
        />
      )}
    </div>
  );
}
